import React, { useState } from 'react';
import './SupportPage.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We\'ll get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="support-page">
      <div className="support-header">
        <h1 className="support-title">Contact Us</h1>
        <p className="support-subtitle">
          Get in touch with our team. We're here to help with any questions or feedback you may have.
        </p>
      </div>
      
      <div className="contact-grid">
        <div className="contact-card">
          <div className="contact-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z" fill="none" stroke="currentColor" strokeWidth="2"/>
              <path d="m3 7 9 6 9-6" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3 className="contact-card-title">Email Support</h3>
          <p className="contact-card-text">
            Send us an email for general inquiries, technical support, or feedback about our platform.
          </p>
          <a href="mailto:support@vfootball.com" className="contact-card-link">
            support@vfootball.com
          </a>
        </div>
        
        <div className="contact-card">
          <div className="contact-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M8 2v4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M16 2v4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <rect width="18" height="18" x="3" y="4" rx="2" fill="none" stroke="currentColor" strokeWidth="2"/>
              <path d="M3 10h18" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3 className="contact-card-title">Business Hours</h3>
          <p className="contact-card-text">
            Our support team is available during these hours to assist you with any questions.
          </p>
          <div className="contact-card-link">
            Monday - Friday: 9:00 AM - 6:00 PM (UTC)
          </div>
        </div>
        
        <div className="contact-card">
          <div className="contact-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" fill="none" stroke="currentColor" strokeWidth="2"/>
              <circle cx="12" cy="17" r=".5" fill="currentColor"/>
            </svg>
          </div>
          <h3 className="contact-card-title">FAQ & Help</h3>
          <p className="contact-card-text">
            Check our comprehensive help center for quick answers to common questions.
          </p>
          <a href="/help" className="contact-card-link">
            Visit Help Center
          </a>
        </div>
      </div>
      
      <div className="support-content">
        <h2>Send us a Message</h2>
        <p>
          Have a specific question or need assistance? Fill out the form below and we'll get back to you as soon as possible.
        </p>
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              className="form-input"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your full name"
            />
          </div>
          
          <div className="form-group">
            <label className="form-label" htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your.email@example.com"
            />
          </div>
          
          <div className="form-group">
            <label className="form-label" htmlFor="subject">Subject *</label>
            <input
              type="text"
              id="subject"
              name="subject"
              className="form-input"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="What is your message about?"
            />
          </div>
          
          <div className="form-group">
            <label className="form-label" htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              className="form-textarea"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Please describe your question or feedback in detail..."
            />
          </div>
          
          <button type="submit" className="form-button">
            Send Message
          </button>
        </form>
        
        <div className="info-box">
          <p>
            <strong>Response Time:</strong> We typically respond to all inquiries within 24 hours during business days. 
            For urgent technical issues, please include "URGENT" in your subject line.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;